import type { TOrganizationJobsListParams } from 'app/queries/jobs/jobsKeys';

export const buildOrganizationJobsRequest = (organizationId: string, params: TOrganizationJobsListParams) => {
  const asOne = Boolean(params.asOne);

  return {
    oid: organizationId,
    statuses: params.statuses,
    pageNo: params.page.toString(),
    pageSize: params.pageSize.toString(),
    orderBy: params.orderBy,
    orderType: params.orderType,
    search: params.search,
    jobsFrom: params.jobsFrom,
    jobsTo: params.jobsTo,
    asOne: asOne || undefined,
    post: (!asOne && params.post) || undefined,
    meetingTypes: asOne && params.meetingTypes?.length ? params.meetingTypes : undefined,
    durationFrom: params.durationFrom === undefined ? undefined : String(params.durationFrom),
    durationTo: params.durationTo === undefined ? undefined : String(params.durationTo),
  };
};
